export type EntitlementPayload = {
  type: "hakofit_entitlement";
  version: 1;
  session_id: string;
  amount_paid: number;
  currency: "jpy";
  design_hash: string;
  design_type: string;
  issued_at: string;
  expires_at: string;
};

export type SignedEntitlement = EntitlementPayload & {
  signature: string;
};

export function parseSignedEntitlementJson(value: unknown): SignedEntitlement {
  if (!isRecord(value)) {
    throw new Error("Entitlement file must contain a JSON object.");
  }

  if (value.type !== "hakofit_entitlement" || value.version !== 1) {
    throw new Error("Entitlement file is not supported.");
  }

  const entitlement: SignedEntitlement = {
    type: "hakofit_entitlement",
    version: 1,
    session_id: requireString(value.session_id),
    amount_paid: requireNumber(value.amount_paid),
    currency: requireCurrency(value.currency),
    design_hash: requireString(value.design_hash),
    design_type: requireString(value.design_type),
    issued_at: requireString(value.issued_at),
    expires_at: requireString(value.expires_at),
    signature: requireString(value.signature)
  };

  return entitlement;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function requireString(value: unknown): string {
  if (typeof value !== "string" || value.length === 0) {
    throw new Error("Entitlement file is missing a required string field.");
  }

  return value;
}

function requireNumber(value: unknown): number {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    throw new Error("Entitlement file is missing a required number field.");
  }

  return value;
}

function requireCurrency(value: unknown): "jpy" {
  if (value !== "jpy") {
    throw new Error("Entitlement currency is not supported.");
  }

  return value;
}
